//
// Attempt to display image and background image specs of images displayed on a page
//

$.fn.imageSpecs = function(options) {
	if ($('body').data('show-image-specs') === true) {

		// Styles
		var styleString =
			'<style>' +
				'.img-spec-wrapper,' +
				'.bgimg-spec-wrapper {' +
					'position: relative !important;' +
					'width: 100% !important;' +
					'height: 100% !important;' +
				'}' +

				'.bgimg-spec-wrapper {' +
					'display: block !important;' +
				'}' +

				'.img-spec {' +
					'color: #666 !important;' +
					'padding: 10px !important;' +
					'font-size: 9px !important;' +
					'position: absolute !important;' +
					'top: 10px !important;' +
					'left: 10px !important;' +
					'max-width: 200px !important;' +
					'min-width: 100px !important;' +
					'background: #fff !important;' +
					'z-index: 10 !important;' +
					'text-align: left !important;' +
					'display: block !important;' +
					'border-radius: 5px !important;' +
					'box-shadow: 2px 2px 5px rgba(0, 0, 0, .25) !important;' +
					'line-height: 1.2 !important;' +
					'font-family: sans-serif !important;' +
					'letter-spacing: 0 !important;' +
				'}' +
				
				'.img-spec dl {' +
					'margin-bottom: 0 !important;' +
				'}' +
				
				'.img-spec dd {' +
					'margin-bottom: 4px !important;' +
				'}' +

				'.img-spec dd:last-child {' +
					'margin-bottom: 0 !important;' +
				'}' +

				'.bgimg-spec-wrapper .img-spec {' +
					'left: auto !important;' +
					'right: 10px !important;' +
				'}' +

				'.img-spec__img {' +
					'display: block !important;' +
					'margin: 0 auto 8px auto !important;' +
					'box-shadow: none !important;' +
					'height: 30px !important;' +
					'width: auto !important;' +
					'max-width: 100px !important;' +
					'position: relative !important;' +
					'top: auto !important;' +
					'left: auto !important;' +
				'}' +
			'</style>';

		// Stick styles in head
		$(styleString)
			.appendTo('head');

		// Setting defaults
		var settings = $.extend({
			'imageExcludeSelectors': '',
			'bgImageExcludeSelectors': '',
			'linkColor': '',
			'controlsParentSelector': 'body'
		}, options);

		// Greatest common denominator
		var gcd = function(a, b) {
			return (b === 0) ? a : gcd(b, a % b);
		};

		// Get file extension
		var getExtension = function(file) {
			var extension = file.substr((file.lastIndexOf('.') + 1)).split('?')[0];

			if (
				extension.toLowerCase() !== 'jpg' &&
				extension.toLowerCase() !== 'jpeg' &&
				extension.toLowerCase() !== 'png' &&
				extension.toLowerCase() !== 'webp' &&
				extension.toLowerCase() !== 'gif' &&
				extension.toLowerCase() !== 'apng' &&
				extension.toLowerCase() !== 'avif' &&
				extension.toLowerCase() !== 'svg'
			) {
				extension = 'unknown';
			}

			return extension;
		};

		// Render the tags
		var renderSpecs = function() {
			var imgEl = $('img').not(settings.imageExcludeSelectors);

			imgEl.each(function() {
				var $img = $(this),
					imgPath = $img.attr('src'),
					imgW = Math.round($img.prop('naturalWidth')),
					imgH = Math.round($img.prop('naturalHeight')),
					commonDenom = gcd(imgW, imgH),
					imgSpecHTML =
					'<span class="img-spec">' +
						'<a tabindex="-1" target="_blank" href="' + imgPath + '">' +
							'<img class="img-spec__img" src="' + imgPath + '">' +
						'<a/>' +
						'<dl>' +
							'<dt>Image size:</dt>' +
							'<dd>' + imgW + 'px x ' + imgH + 'px</dd>' +
							'<dt>File type:</dt>' +
							'<dd>' + getExtension(imgPath) + '</dd>' +
							'<dt>Aspect ratio:</dt>' +
							'<dd>' + imgW / commonDenom + ':' + imgH / commonDenom + '</dd>' +
						'</dl>' +
					'</span>';
					
				$img
					.wrap('<span class="img-spec-wrapper"></span>')
					.parent()
					.append(imgSpecHTML);
			});

			// Tag each background image with it's original size
			var bgImgEl = $('[style*="background-image:"]').not(settings.bgImageExcludeSelectors);

			bgImgEl.each(function() {
				var $bgImage = $(this);

				if ($bgImage.css('background-image') !== 'none') {
					var bgImg = $(this).css('background-image')
						.replace(/^url\(['"]?/, '')
						.replace(/['"]?\)$/, '');

					$('<img/>').attr('src', bgImg).on('load', function(i) {
						var bgImgW = Math.round($(this).prop('naturalWidth')),
							bgImgH = Math.round($(this).prop('naturalHeight')),
							commonDenom = gcd(bgImgW, bgImgH),
							bgImgSpec =
							'<span class="img-spec">' +
								'<a tab-index="-1" target="_blank" href="' + bgImg + '">' +
									'<img class="img-spec__img" src="' + bgImg + '">' +
								'<a/>' +
								'<dl>' +
									'<dt>BG image size:</dt>' +
									'<dd>' + bgImgW + 'px x ' + bgImgH + 'px</dd>' +
									'<dt>File type:</dt>' +
									'<dd>' + getExtension($(this).attr('src')) + '</dd>' +
									'<dt>Aspect ratio:</dt>' +
									'<dd>' + bgImgW / commonDenom + ':' + bgImgH / commonDenom + '</dd>' +
								'</dl>' +
							'</span>';

						$(this).remove();

						$bgImage
							.wrap('<span class="bgimg-spec-wrapper"></span>')
							.parent()
							.prepend(bgImgSpec);
					});
				}
			});
		};

		// Remove
		var removeSpecs = function() {
			$('.img-spec').remove();
			$('.img-spec-wrapper > *, .bgimg-spec-wrapper > *').unwrap();
		};

		// Render controls           
		$('<span>')
			.css({
				'display': 'inline-flex',
				'margin-right': '15px'
			})
			.addClass('image-spec-controls')
			.prependTo(settings.controlsParentSelector);

		// Build image spec checkbox
		$('<input>')
			.attr('id', 'showImageSpecs')
			.attr('type', 'checkbox')
			.css('margin-right', '10px')
			.prependTo('.image-spec-controls');

		// Build image spec checkbox label
		$('<label>')
			.attr('for', 'showImageSpecs')
			.css('margin-bottom', '0')
			.html('Image specs')
			.appendTo('.image-spec-controls');

		// Control checkbox click
		$('#showImageSpecs').on('click', function() {
			var $checkbox = $(this);

			if ($checkbox.prop('checked') === true) {
				renderSpecs();
			} else {
				removeSpecs();
			}
		});
	}
};